import AppRoutes from './router';
import '@/assets/scss/global.scss'
import '@/styles/global.css'

function App() {
  return <AppRoutes />
}

export default App;
